import React, { useEffect, useState } from "react";
import { Table, Space, Row, Col, Input, Select, Button, Form, Checkbox, DatePicker, notification, message, Modal, Spin } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { Option } from "antd/es/mentions";
import { awsService, dropdownService, vehicleService } from "../../../../services";
import { VEHICLES } from "../../../../constants";
import { useNavigate } from "react-router-dom";
import ImageUploader from "../../../../components/ImageUploader";

const car_status = [
  {
    value: "AT YARD",
    label: "AT YARD"
  },
  {
    value: "LOAD PLAN",
    label: "LOAD PLAN"
  },
  {
    value: "LOADED",
    label: "LOADED"
  },
  {
    value: "RETURNED",
    label: "RETURNED"
  },
]

const AT_YARD = car_status[0].value;

const keys = [
  {
    value: "YES",
    label: "YES"
  },
  {
    value: "NO",
    label: "NO"
  },
  {
    value: "BROKEN",
    label: "BROKEN"
  }
]

function PortalVerion() {
  const navigate = useNavigate()
  const [activeRowId, setActiveRowId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [appointmentLoading, setAppointmentLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);

  const [customers, setCustomers] = useState([]);
  const [cars, setCars] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null);
  const [tableData, setTableData] = useState([{
    Id: "",
    status: "AT YARD",
    user_id: "",
    Lot_no: "",
    CuttingCar: false,
    make: "",
    model: "",
    delivery_type: "",
    EngineType: "",
    year: "",
    vin: "",
    DateRcd: "",
    Value: "",
    Weight: "",
    OperatingPort: "",
    BOS: "",
    TitleOwner: "",
    Title: "",
    TitleNumber: "",
    isKey: "",
    Notes: "",
    FileRef: "",
    FileUpload: null,
  }]);
  const [first_id, setFirst_id] = useState();
  const [vin, setVin] = useState([])
  const [selectedVin, setSelectedVin] = useState(null);

  const [modalVisible, setModalVisible] = useState(false);
  const activeRow = tableData.find(row => row.Id === activeRowId);
  const activeFileList = activeRow?.FileUpload || [];

  const columns = [
    {
      title: "Customer",
      dataIndex: "user_id",
      key: "user_id",
      width: 150,
      render: (text, record) => {
        return (
          <Select
            value={record.user_id}
            style={{ width: "100%" }}
            placeholder="Select Customer"
            loading={customerLoading}
            showSearch
            dropdownStyle={{ minWidth: 150 }}
            optionFilterProp="children"
            onChange={(value) => handleInputChange(value, record.Id, "user_id")}
          >
            {customers.map(c => (
              <Select.Option key={c.id} value={c.id}>
                {c.name}
              </Select.Option>
            ))}
          </Select>
        );
      },
    },
    {
      title: "VIN Number",
      width: 200,
      dataIndex: "vin",
      key: "vin",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Enter Chasis No"
          onChange={(e) => handleInputChange(e.target.value, record.Id, "vin")}
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },
    {
      title: "Year",
      width: 200,
      dataIndex: "year",
      key: "year",
      render: (text, record, index) => (
        <Input
          type="number"
          value={text}
          placeholder="Select Year "
          onChange={(e) =>
            handleInputChange(e.target.value, record.Id, "year")
          }
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },
    {
      title: "Make",
      width: 200,
      dataIndex: "make",
      key: "make",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Enter Product"
          onChange={(e) => handleInputChange(e.target.value, record.Id, "make")}
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },
    {
      title: "Model",
      dataIndex: "model",
      width: 200,
      key: "model",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Enter Vehicle"
          onChange={(e) =>
            handleInputChange(e.target.value, record.Id, "model")
          }
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },
    {
      title: "Type",
      dataIndex: "delivery_type",
      width: 200,
      key: "delivery_type",
      render: (text, record) => {
        return (
          <Select
            placeholder="select Type"
            value={text}
            style={{ width: "100%" }}
            onChange={(value) =>
              handleInputChange(value, record.Id, "delivery_type")
            }
            dropdownStyle={{ minWidth: 150 }}
          >
            <Option value="Car">Car</Option>
            <Option value="Bike">Bike</Option>
            <Option value="Boat">Boat</Option>
            <Option value="General Cargo">General Cargo</Option>
            <Option value="Heavy Equipment">Heavy Equipment</Option>
            <Option value="Miscellaneous">Miscellaneous</Option>
          </Select>
        );
      },
    },
    {
      title: "Keys",
      width: 200,
      dataIndex: "isKey",
      key: "isKey",
      render: (text, record, index) => {
        let val;
        if (text === 1) {
          val = "YES";
        } else if (text === 0) {
          val = "NO";
        }

        return (
          <Select style={{ width: "100%" }} onChange={(value) => handleInputChange(value, record.Id, "isKey")}>
            {keys.map((key) => (
              <Select.Option key={key.value} value={key.value}>{key.label}</Select.Option>
            ))}
          </Select>
        );
      },
    },
    {
      title: "Date Received",
      dataIndex: "DateRcd",
      width: 200,
      key: "DateRcd",
      render: (text, record, index) => (
        <DatePicker
          // value={text}
          placeholder="YYYY/MM/DD"
          onChange={(date, dateString) =>
            handleInputChange(dateString, record.Id, "DateRcd")
          }
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },

    {
      title: "Title",
      dataIndex: "Title",
      width: 150,
      key: "Title",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Enter Title "
          onChange={(e) =>
            handleInputChange(e.target.value, record.Id, "Title")
          }
          style={{ width: "100%" }}
        />
      ),
    },
    {
      title: "Title Number",
      dataIndex: "TitleNumber",
      width: 150,
      key: "TitleNumber",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Enter Title Number "
          onChange={(e) =>
            handleInputChange(e.target.value, record.Id, "TitleNumber")
          }
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },
    {
      title: "Title Owner",
      dataIndex: "TitleOwner",
      width: 150,
      key: "TitleOwner",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Enter Title Owner "
          onChange={(e) =>
            handleInputChange(e.target.value, record.Id, "TitleOwner")
          }
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },
    {
      title: "BOS",
      width: 150,
      dataIndex: "BOS",
      key: "BOS",
      render: (text, record) => (
        <Select
          defaultValue={text}
          onChange={(value) => handleInputChange(value, record.Id, "BOS")}
          style={{ width: "100%" }}
          placeholder="select BOS"
        >
          <Option value="Auction">Auction</Option>
          <Option value="Notarized">Notarized</Option>
          <Option value="Non-Notarized">Non-Notarized</Option>
        </Select>
      ),
    },

    {
      title: "Weight",
      dataIndex: "Weight",
      width: 200,
      key: "Weight",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Enter Weight"
          onChange={(e) =>
            handleInputChange(e.target.value, record.Id, "Weight")
          }
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },
    {
      title: "Value",
      dataIndex: "Value",
      width: 200,
      key: "Value",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Enter Value "
          onChange={(e) =>
            handleInputChange(e.target.value, record.Id, "Value")
          }
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },
    {
      title: "Engine Type",
      dataIndex: "EngineType",
      key: "EngineType",
      width: 200,
      render: (text, record) => (
        <Select
          placeholder="Select Engine Type"
          defaultValue={text}
          style={{ width: "100%" }}
          dropdownStyle={{ minWidth: 180 }}
          onChange={(value) =>
            handleInputChange(value, record.Id, "EngineType")
          }
        >
          <Option value="GASOLINE">GASOLINE</Option>
          <Option value="HYBRID">HYBRID</Option>
          <Option value="EV">EV</Option>
        </Select>
      ),
    },
    {
      title: "Operating Port",
      width: 200,
      dataIndex: "OperatingPort",
      key: "OperatingPort",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Enter Operating Port "
          onChange={(e) =>
            handleInputChange(e.target.value, record.Id, "OperatingPort")
          }
          style={{ width: "100%" }} // Make sure input fills the column width]
        />
      ),
    },
    {
      title: "Notes",
      width: 200,
      dataIndex: "Notes",
      key: "Notes",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Enter Notes  "
          onChange={(e) =>
            handleInputChange(e.target.value, record.Id, "Notes")
          }
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },
    {
      title: "File Ref",
      width: 200,
      dataIndex: "FileRef",
      key: "FileRef",
      render: (text, record, index) => (
        <Input
          value={record.FileRef || ""}
        //   readOnly={record.FileRefReadonly}
          placeholder="Enter File Ref"
          onChange={(e) =>
            // !record.FileRefReadonly &&
            handleInputChange(e.target.value, record.Id, "FileRef")
          }
        />
      ),
    },
    {
      title: "Cutting Car",
      dataIndex: "CuttingCar",
      key: "CuttingCar",
      render: (checked, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Checkbox
            checked={checked}
            onChange={(e) =>
              handleInputChange(e.target.checked, record.Id, "CuttingCar")
            }
          />
        </div>
      ),
    },

    {
      title: "Lot#",
      dataIndex: "Lot_no",
      key: "Lot_no",
      width: 200,
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder=" Enter Lot#"
          onChange={(e) =>
            handleInputChange(e.target.value, record.Id, "Lot_no")
          }
          style={{ width: "100%" }} // Make sure input fills the column width
        />
      ),
    },
    {
      title: "Car Status",
      dataIndex: "status",
      key: "status",
      width: 200,
      render: (text, record, index) => {
        return (
          <Select style={{ width: "100%" }} onChange={(value) => handleInputChange(value, record.Id, "status")} defaultValue="AT YARD"	>
            {car_status.map((status) => (
              <Select.Option key={status.value} value={status.value}>{status.label}</Select.Option>
            ))}
          </Select>
        );
      },
    },

    {
      title: "Pictures",
      dataIndex: "FileUpload",
      key: "FileUpload",
      render: (text, record) => {
        // const currentFileList = record.FileUpload || [];

        const handleFileChange = (info) => {
          const { fileList } = info;

          setTableData(prev =>
            prev.map(row =>
              row.Id === activeRowId
                ? { ...row, FileUpload: fileList }
                : row
            )
          );
        };

        const handleDeleteAll = () => {
          setTableData(prev =>
            prev.map(row =>
              row.Id === activeRowId
                ? { ...row, FileUpload: [] }
                : row
            )
          );
        };

        return (
          <>
            <Button
              type="primary"
              onClick={() => {
                setActiveRowId(record.Id);
                setModalVisible(true);
              }}
            >
              {record.FileUpload?.length > 0
                ? `${record.FileUpload.length} images`
                : "Upload"}
            </Button>


            <Modal
              title="Image Upload"
              open={modalVisible}
              footer={null}
              onCancel={() => {
                setModalVisible(false);
                setActiveRowId(null);
              }}
              width={700}
            >
              <div className="flex justify-end">
                <Button onClick={handleDeleteAll} danger>Delete All Images</Button>
              </div>
              <div className="mb-3">
                <ImageUploader
                  fileList={activeFileList}
                  beforeUpload={true}
                  handleChange={handleFileChange}
                  length={100}
                  remove={false}
                />
                {/* Fixed Footer */}
                <div className="flex justify-between items-center p-4 mt-4 border-t border-gray-200">
                  <p style={{ border: "1px solid #ccc", padding: "8px", borderRadius: "16px" }}>
                    {activeFileList.length} images selected
                  </p>

                  {activeFileList.length > 0 && (
                    <Button type="primary" onClick={() => setModalVisible(false)}>
                      Done
                    </Button>
                  )}
                </div>
              </div>

            </Modal>
          </>
        );
      }
    },
    {
      title: "Delete",
      key: "Delete",
      render: (text, record, index) => {
        return (
          <Button
            type="primary"
            s
            size="small"
            onClick={() => handleDeleteRow(record.Id)}
          >
            <DeleteOutlined />
          </Button>
        );
      },
    },
  ]

  const getNextFileRef = (baseFileRef = "", existingFileRefs = [], opts = { alwaysIncrementBase: false }) => {
    if (!baseFileRef) return "";

    // capture prefix and trailing number, e.g. "CC-0002" => ["CC-000", "2"]
    const m = String(baseFileRef).match(/^(.+?)(\d+)$/);
    if (!m) {
      // no trailing digits: return base (no increment logic)
      return baseFileRef;
    }

    const prefix = m[1];
    const baseNum = parseInt(m[2], 10);
    const baseNumLen = m[2].length;

    const reg = new RegExp(`^${prefix}(\\d+)$`);

    // extract numbers from existing file refs that match prefix
    const nums = existingFileRefs
      .map(fr => {
        if (!fr) return null;
        const mm = String(fr).match(reg);
        return mm ? parseInt(mm[1], 10) : null;
      })
      .filter(n => n != null);

    let nextNum;

    if (nums.length === 0) {
      // no existing numbers in table for this prefix
      if (opts.alwaysIncrementBase) {
        // ALWAYS increment base (used when last_file_ref is provided by backend)
        nextNum = baseNum + 1;
      } else {
        // KEEP base (used when only file_ref exists and we want first selection to be base)
        nextNum = baseNum;
      }
    } else {
      // some numbers exist in table — increment the maximum of (existing, base)
      const maxExisting = Math.max(...nums);
      const maxNum = Math.max(maxExisting, baseNum);
      nextNum = maxNum + 1;
    }

    const nextNumStr = String(nextNum).padStart(baseNumLen, "0");
    return `${prefix}${nextNumStr}`;
  };

  const handleInputChange = (value, recordId, field) => {
    setTableData(prev =>
      prev.map(row => {
        if (row.Id !== recordId) return row;

        const updatedRow = { ...row, [field]: value };

        if (field === "user_id") {
          const selected = customers.find(c => c.id === value);

          if (!selected) {
            // cleared selection
            updatedRow.FileRef = "";
            updatedRow.FileRefReadonly = false;
            return updatedRow;
          }

          // Determine baseRef: prefer last_file_ref, fallback to file_ref
          const lastRef = selected.last_file_ref ?? null;
          const fileRef = selected.file_ref ?? null;
          const baseRef = lastRef || fileRef || null;

          // If backend has no file refs, keep editable empty (same as you requested)
          if (!baseRef) {
            updatedRow.FileRef = "";
            updatedRow.FileRefReadonly = false;
            return updatedRow;
          }

          // existing file refs in table excluding current row
          const existingFileRefs = prev
            .filter(r => r.Id !== recordId)
            .map(r => r.FileRef)
            .filter(Boolean);

          // if last_file_ref exists, always increment the base; otherwise (only file_ref) keep base on first pick
          const alwaysIncrement = !!lastRef;

          const nextFileRef = getNextFileRef(baseRef, existingFileRefs, { alwaysIncrementBase: alwaysIncrement });

          updatedRow.FileRef = nextFileRef;
          updatedRow.FileRefReadonly = true;
        }

        return updatedRow;
      })
    );
  };


  const handleSelectChange = (value) => {
    const selectedCar = cars.find((car) => car.id === value);
    setSelectedCar(selectedCar);
  };

  const addRow = () => {
    setTableData((prevData) => {
      const newId =
        prevData.length > 0 ? prevData[prevData.length - 1].Id + 1 : first_id;
      const newRow = {
        Id: newId,
        status: AT_YARD,
        user_id: "",
        Lot_no: "",
        CuttingCar: false,
        make: "",
        model: "",
        delivery_type: "",
        EngineType: "",
        year: "",
        vin: "",
        DateRcd: "",
        Value: "",
        Weight: "",
        OperatingPort: "",
        BOS: "",
        TitleOwner: "",
        Title: "",
        TitleNumber: "",
        isKey: "",
        Notes: "",
        FileRef: "",
        FileUpload: null,
      };

      return [...prevData, newRow];
    });
  };

  const getAppointedCars = async () => {
    setAppointmentLoading(true);
    const response = await dropdownService.fetchApprovedCars();
    if (response.success) {
      setCars(response.data);
    }
    setAppointmentLoading(false);
  };

  const handleAdd = () => {
    const isDuplicateVin = tableData.some((row) => row.vin === selectedCar.vin);

    if (isDuplicateVin) {
      message.error("This VIN number already exists in the table.");
      return;
    }

    if (selectedCar && tableData.length > 0) {
      setTableData((prevTableData) => {
        const emptyRowIndex = prevTableData.findIndex(
          (row) => !row.make && !row.model && !row.vin
        );

        const targetIndex =
          emptyRowIndex !== -1 ? emptyRowIndex : prevTableData.length - 1;

        const { id, status: AT_YARD, ...selectedCarData } = selectedCar;

        const updatedData = [...prevTableData];
        updatedData[targetIndex] = {
          ...updatedData[targetIndex],
          ...selectedCarData,
        };

        return updatedData;
      });
    }
  };

  const getLatestId = async () => {
    setLoading(true);
    const response = await vehicleService.getLatestID();
    setLoading(false);
    if (response.success) {
      const latestId = response.data[0].highest_id + 1;
      // setTableData([...Id: latestId]);
      setTableData(prev =>
        prev.map((item, index) =>
          index === 0
            ? { ...item, Id: latestId }
            : item
        )
      );
      setFirst_id(latestId);
    }
  };

  const handleDeleteRow = (Id) => {
    setTableData((prev) => {
      // Step 1: Find the smallest ID in the original data
      const baseId = Math.min(...prev.map((row) => row.Id));
      // Step 2: Filter out the row to delete
      const filteredData = prev.filter((row) => row.Id !== Id);
      // Step 3: Reassign IDs sequentially, starting from the original smallest ID
      const updatedData = filteredData.map((row, index) => ({
        ...row,
        Id: baseId + index,
      }));

      return updatedData;
    });
  };

  const handleImagesAdd = () => {
    if (!selectedVin) {
      return message.error("Please select a VIN number first.");
    }

    const selectedCar = vin.find((car) => car.id === selectedVin);

    if (!selectedCar?.images || selectedCar.images.length === 0) {
      return message.warning("No images found for the selected VIN.");
    }

    const fakeFileObjects = selectedCar.images.map((url, index) => ({
      uid: `-${Date.now()}-${index}`,
      name: `image_${index}.jpg`,
      status: 'done',
      url,
      thumbUrl: url,
      originFileObj: {
        name: `image_${index}.jpg`,
        status: 'done',
        type: "existing",
      },
    }));

    setTableData(prev =>
      prev.map(row =>
        row.Id === activeRowId
          ? {
            ...row,
            FileUpload: [
              ...(row.FileUpload || []),
              ...fakeFileObjects,
            ],
          }
          : row
      )
    );

    message.success("Images added.");
  };

  const onFinish = async () => {
    // Validate FileRef presence first
    const missing = tableData
      .filter(r => !r.FileRef || String(r.FileRef).trim() === "")
      .map(r => r.Id);

    if (missing.length > 0) {
      message.error(
        `Customer has no File Ref in the system.\nPlease contact management to add the File Ref for this customer.\n(Affected row(s): ${missing.join(", ")})`
      );
      return;
    }

    setLoading(true);
    try {
      const newData = await Promise.all(
        tableData.map(async (row) => {
          let formData = {
            BOS: row.BOS,
            car_status: row.status,
            chasis_no: row.vin,
            cutting_car: row.CuttingCar ? 1 : 0,
            date_rcd: row.DateRcd,
            engine_type: row.EngineType,
            file_ref: row.FileRef,
            keys: row.isKey,
            "lot_#": row.Lot_no,
            notes: row.Notes,
            operating_port: row.OperatingPort,
            product: row.make,
            title: row.Title,
            title_number: row.TitleNumber,
            title_owner: row.TitleOwner,
            user_id: row.user_id,
            value: row.Value,
            vehicle: row.model,
            vehicle_type: row.delivery_type,
            weight: row.Weight,
            year: row.year,
            FileUpload: row.FileUpload,
          };

          const vehicleImages = formData.FileUpload || [];

          const existingImages = vehicleImages.filter(file => file.originFileObj?.type === "existing");
          const newImages = vehicleImages.filter(file => file.originFileObj?.type !== "existing");
          const existingImageUrls = existingImages.map(file => file.url);

          formData.vehicle_uploaded_id = selectedVin;
          formData.vehicle_uploaded_images = existingImageUrls;

          if (newImages.length > 0) {
            const userName = customers.find((i) => i.id === row.user_id)?.name ?? "unknown";

            try {
              const uploadedImages = await awsService.uploadS3Bucket(vehicleImages, userName, formData.chasis_no, VEHICLES);
              formData.FileUpload = uploadedImages;
            } catch (error) {
              console.error(`Failed to upload images for ${row.vin}:`, error);
              formData.FileUpload = []; // Set as empty array if upload fails
            }
          } else {
            formData.FileUpload = [];
          }

          return { [row.Id]: formData };
        })
      );

      const requestData = newData.reduce((acc, cur) => ({ ...acc, ...cur }), {});

      const response = await vehicleService.addVehicle(requestData);
      setLoading(false);

      if (response?.success) {
        notification.success({ message: "Added Successfully!", description: response.message, placement: "topRight" });
        navigate('/vehicle');
      } else {
        message.error(response?.message || "Failed to save records.");
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      message.error("An unexpected error occurred while saving.");
    }
  };


  const getCustomer = async () => {
    setCustomerLoading(true);
    const response = await dropdownService.fetchCustomers();
    if (response.success) {
      const filter = response.data.sort((a, b) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      );

      const capitalizedFilter = filter.map((customer) => ({
        ...customer,
        name: customer.name.toUpperCase(),
      }));
      setCustomers(capitalizedFilter);
    }
    setCustomerLoading(false);
  };

  const getVin = async () => {
    const response = await dropdownService.fetchVin();
    if (response.success) {
      setVin(response.data);
    }
  }

  useEffect(() => {
    getCustomer();
    getLatestId();
    getAppointedCars();
    getVin();
  }, []);

  return (
    <div
      style={{
        padding: "15px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <div style={{ marginTop: 20 }}>
        <Form requiredMark={false} layout="vertical">
          <Row gutter={[24, 24]}>
            {/* First Column: Vin Input */}
            <Col xs={24} sm={8}>
              <Form.Item label="Approved Appointment Cars Vin #">
                <Select
                  optionFilterProp="children"
                  showSearch
                  placeholder="Select Appointment Car"
                  loading={appointmentLoading}
                  notFoundContent={loading ? <Spin size="small" /> : null}
                  onChange={(value) => handleSelectChange(value)}
                >
                  {cars.map((car) => (
                    <Select.Option key={car.id} value={car.id}>
                      {car.vin} - {car.make} - {car.model}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* Second Column: Add Button */}
            <Col xs={24} sm={1}>
              <Form.Item
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "28px",
                }}
              >
                <Button
                  type="primary"
                  style={{ textAlign: "center" }}
                  onClick={handleAdd}
                >
                  Add
                </Button>
              </Form.Item>
            </Col>

            <Col xs={24} sm={8} md={8} className="ml-8">
              <Form.Item label="Vin No" >
                <Select
                  placeholder="Enter Vin No"
                  allowClear
                  onSelect={(value) => setSelectedVin(value)}
                  loading={loading}
                  showSearch
                  optionFilterProp="children"
                >
                  {vin.map((vin) => (
                    <Select.Option key={vin.id} value={vin.id}>{vin.vin}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={1}>
              <Form.Item
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "28px",
                }}
              >
                <Button
                  type="primary"
                  style={{ textAlign: "center" }}
                  onClick={handleImagesAdd}
                >
                  Add
                </Button>
              </Form.Item>
            </Col>

          </Row>
        </Form>
      </div>
      <Row
        gutter={[0, 0]}
        style={{
          marginTop: "10px",
          background: "#F2F2F7",
          padding: "10px",
          borderRadius: "4px",
        }}
        justify="space-between" // Align items in the row
        align="middle" // Vertically align items in the center
      >
        {/* Left section */}
        <Col
          xs={24}
          lg={24}
          style={{ display: "flex", justifyContent: "flex-end", textAlign: "right" }}
        >
          {/* <Space size={10}> */}
          <Button type="primary" onClick={addRow}>
            Add Row
          </Button>
        </Col>

        {/* Right section */}

      </Row>
      <div>
        <Table
          columns={columns}
          scroll={{ x: "max-content" }}
          dataSource={tableData}
          rowKey="Id"
          style={{ marginTop: "10px" }}
          pagination={false}
        />
      </div>

      <Col
        xs={24}
        md={24}
        style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}
      >
        <Space wrap>
          <Button
            type="primary"
            onClick={onFinish}
            loading={loading}
          >
            Save Records
          </Button>
        </Space>
      </Col>
    </div>
  );
}

export default PortalVerion;
